import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { inject, observer } from 'mobx-react';

//elements
import Select from '~/elements/Select.js';
import { Input } from '~/elements/Input.js';
import RequiredStar from '~/elements/RequiredStar.js';
import Button from '~/components/CustomButton/CustomButton';

//utils
import { payrollIntegrationOptions, DEFAULT_VACATION_NORMAL_WAGE_TYPE } from '~/utils/constants';
import { validateRequestPayload, resolveWageTypeCodeLabel } from '~/utils/commonMethods';

const defaultSettingsCodeForDisabling = ["normal", "nonpaid", "imported", "carry"];

const AddEditVacationTypeForm = ({ values, onSave, onCancel, payroll_wagetypes, t, integrationType, vacationCodes, commonStore }) => {
    const defaultNormalWageType = values?.code === 'normal'
        ? resolveWageTypeCodeLabel(DEFAULT_VACATION_NORMAL_WAGE_TYPE[integrationType], commonStore)
        : null;
    const payrollWageTypeOptions = payroll_wagetypes?.map(item => ({ value: item.value, label: item.label, projectDbId: item.projectDbId }));
    // const vacationCodeOptions = vacationCodes?.map(item => ({ value: item.value, label: item.label }));
    const [code, setCode] = useState(values?.code);
    const [name, setName] = useState(values?.name);
    const [payrollWageType, setPayrollWageType] = useState(values?.payrollWageType);
    const [hourlyWageType, setHourlyWageType] = useState(values?.hourlyPayrollWageType);
    // const [vacationCode, setVacationCode] = useState(values?.vacationCode);

    const handleOnSave = () => {
        const data = {};
        if (code) data.code = code;
        if (name) data.name = name;
        if (payrollWageType) data.payrollWageType = payrollWageType;
        data.hourlyPayrollWageType = hourlyWageType || null;
        // if (vacationCode) data.vacationCode = vacationCode;
        if (values?.code && defaultSettingsCodeForDisabling.includes(values.code) && values.code !== code) {
            return commonStore.addNotification(t("Can't edit default setting code", null, 'warning'));
        }
        if (!values?.code && defaultSettingsCodeForDisabling.includes(code)) {
            return commonStore.addNotification(t("Can't add default setting code", null, 'warning'));
        }
        const validFields = ["code", "name"];
        const validMessage = ["Code", "Label"];
        const errors = validateRequestPayload(data, validFields, validMessage, t);
        if (errors) {
            onSave({ hasError: true, errors: errors });
        } else {
            onSave(data);
        }
    };

    return (
        <>
            <Row className="mt-4">
                <Col xs={4} sm={3}>
                    <label className="control-label">{t('Code')} <RequiredStar /></label>
                    <Input value={code}
                        disabled={defaultSettingsCodeForDisabling.includes(values?.code)}
                        onChange={(e) => setCode(e.target.value)} placeholder={t('Enter code')} />
                </Col>

                <Col xs={6} sm={3}>
                    <label className="control-label">{t('Label')} <RequiredStar /></label>
                    <Input value={name} onChange={(e) => setName(e.target.value)} placeholder={t('Enter label')} />
                </Col>
            </Row>

            {payroll_wagetypes?.length > 0 && (
                <Row className='mt-3'>
                    <Col xs={6}>
                        <label className="control-label">
                            {integrationType === payrollIntegrationOptions.XLEDGER || integrationType === payrollIntegrationOptions.TRIPLETEX ? t('Activity') : t('Wage Type')} ({t('Fixed Salary')})
                        </label>
                        <Select
                            options={payrollWageTypeOptions || []}
                            value={payrollWageType}
                            onChange={(value) => setPayrollWageType(value)}
                            isClearable
                            placeholder={integrationType === payrollIntegrationOptions.XLEDGER || integrationType === payrollIntegrationOptions.TRIPLETEX ? t('Select Activity') : t('Select Wage Type')}
                        />
                    </Col>
                    <Col xs={6}>
                        <label className="control-label">
                            {integrationType === payrollIntegrationOptions.XLEDGER || integrationType === payrollIntegrationOptions.TRIPLETEX ? t('Activity') : t('Wage Type')} ({t('Hourly')})
                        </label>
                        <Select
                            options={payrollWageTypeOptions || []}
                            value={hourlyWageType}
                            onChange={(value) => setHourlyWageType(value)}
                            isClearable
                            placeholder={integrationType === payrollIntegrationOptions.XLEDGER || integrationType === payrollIntegrationOptions.TRIPLETEX ? t('Select Activity') : t('Select Wage Type')}
                        />
                    </Col>
                    {/* {integrationType === payrollIntegrationOptions.XLEDGER && (
                        <Col xs={6} className="mb-3">
                            <label className="control-label">
                                {t('Vacation Code')} <RequiredStar />
                            </label>
                            <Select
                                options={vacationCodeOptions || []}
                                value={vacationCode}
                                onChange={(value) => setVacationCode(value)}
                                placeholder={t('Select Vacation Code')}
                            />
                        </Col>
                    )} */}
                </Row>
            )}

            {defaultNormalWageType &&
                <Row>
                    <Col xs={12}>
                        <p className='font-size-12 fw-bold'><RequiredStar /><RequiredStar />
                            {t('If left blank, the system will use its built-in default wage type')}: "{defaultNormalWageType}".
                        </p>
                    </Col>
                </Row>
            }

            <div className="d-flex justify-content-end mt-4">
                <Button type="button" className="me-2" onClick={onCancel}>
                    {t('Cancel')}
                </Button>
                <Button type="button" wd fill onClick={() => handleOnSave()}>
                    {values?.id ? t('Update') : t('Save')}
                </Button>
            </div>
        </>
    );
};

export default inject('commonStore')(observer(AddEditVacationTypeForm));
